import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import ReactGA from 'react-ga4'
import { ToastProvider } from './components/ToastProvider'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Home from './pages/Home'
import ToolPage from './pages/ToolPage'
import About from './pages/About'
import Privacy from './pages/Privacy'
import Contact from './pages/Contact'
import NotFound from './pages/NotFound'

// Initialise Google Analytics 4 once (react-ga4 injects gtag.js for us).
ReactGA.initialize('G-PXKL81MR0Y')

// Sends a page_view on every route change. Must live INSIDE <BrowserRouter>
// so useLocation() has a router context.
function Shell() {
  const location = useLocation()
  useEffect(() => {
     ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location])

  return (
    <ToastProvider>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/tool/:id" element={<ToolPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </ToastProvider>
  )
}

function App() {
  return (
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  )
}

export default App
